// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { CdEnvironment } from '@env/environment.interface';

export const environment: CdEnvironment = {
  production: false,
  // Split-origin: the SPA is served by a Cloudflare Worker on dev-dapp.coindepo.io
  // and the API lives on the shared dev-api host, exactly as coin-depo does it.
  // (Was same-origin https://dev-dapp.coindepo.io/dapi/ — CD-3557.)
  serverUrl: 'https://dev-api.coindepo.io/dapi/',
  serverAuthUrl: 'https://dev-api.coindepo.io/',
  staticUrl: 'https://dev-static.coindepo.io/',
  env: 'dev',
  APP_URL: 'https://dev-app.coindepo.io',
  contract: '0xdB3CF6EF1672AC9a717AcA56Ff913a86c7FC3AB0',
  supportedNetworkID: [11155111, 97, 80001, 43113],
  chains: [
    { 
      name: 'Ethereum Sepolia', 
      chainId: 11155111, 
      rpcUrl: 'https://sepolia.infura.io/v3/adaf902a3536415c8bba1581f86bad87',
      icon: '/assets/images/ethereum.svg'
    },
    { 
      name: 'BSC Testnet', 
      chainId: 97, 
      rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
      icon: '/assets/images/bnb.svg'
    },
    { 
      name: 'Polygon Testnet', 
      chainId: 80001, 
      rpcUrl: 'https://matic-mumbai.chainstacklabs.com',
      icon: '/assets/images/polygon.svg'
    },
    { 
      name: 'Avalanche Testnet', 
      chainId: 43113, 
      rpcUrl: 'https://api.avax-test.network/ext/bc/C/rpc',
      icon: '/assets/images/avax_avax.svg'
    }
  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
